module.exports = __webpack_public_path__ + "img/logo-home1.707f6c8c.png";